export default {
  schedules: {
    type: Array,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/schedulings/components/available/resources/props.js